module.exports = __webpack_public_path__ + "top_page/top-industry-work-c5e40eca1264f36812bd3a63b00344cf.svg";